<template>
    <layout>
        <main role="main" class="background-employer-dashboard pt-sm-3">
            <header-size-one :title="Lang.get('employeedashboard::pages/dashboard/dashboard.title')"
                             :subtitle="Lang.get('employeedashboard::pages/dashboard/dashboard.intro')"/>
            <div class="dashboard-container mb-4">

                <div class="tall-box">
                    <find-your-next-course :widgets="widgets"/>
                </div>

                <div class="small-box budget">
                    <card-box-small
                        :title="Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.budget.title')"
                        :main-content="$page.props.auth.user.available_budget | toCurrency"
                        :extra-info="budget.latest_deposit"/>
                </div>
                <div class="small-box bookings">
                    <card-box-small
                        :title="Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.your_booking.title')"
                        :main-content="bookingsCount" :extra-info="bookingDescription"/>
                </div>

                <template v-if="tiles.data_camp !== undefined && tiles.data_camp.is_active === true">
                    <div class="wide-box">
                        <card-box-small-banner
                            image-url="/img/employee-dashboard/datacamp.png"
                            :link-url="route('nl.employeedashboard.searchAndBook', {searchQuery: 'datacamp'})"
                            background-size="contain"
                            background-position="right 10px center"
                            background-color="#06182e"
                            max-width="60%"
                            default-slot-class="ps-1 p-4 text-left"
                        >
                            <h4 class="font-poppins color-white mb-4 line-height-medium balance">
                                {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.data_camp.title') }}
                            </h4>
                            <div class="btn bg-fire-orange color-white font-poppins font-weight-bolder radius-19 align-self-center me-3">
                                {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.data_camp.button') }}
                            </div>
                        </card-box-small-banner>
                    </div>
                </template>
            </div>
        </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import HeaderSizeOne from "@/Shared/HeaderSizeOne";
import CardBoxSmall from "@/Shared/CardBoxSmall";
import FindYourNextCourse from "./components/FindYourNextCourse.vue";
import IngFindYourNextCourse from "./components/IngFindYourNextCourse.vue";
import CardBoxWide from "@/Shared/CardBoxWide.vue";
import CardBoxSmallBanner from "../../Shared/CardBoxSmallBanner.vue";

export default {
    metaInfo() {
        return {
            title: Lang.get('employeedashboard::pages/dashboard/dashboard.meta.title'),
        }
    },
    data() {
        return {
            bookingDescription: this.ordersInSyncCount > 0 ?
                Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.your_booking.description_not_synced') :
                Lang.choice('employeedashboard::pages/dashboard/dashboard.widgets.your_booking.description', this.bookingsCount, { 'count': this.bookingsCount })
        }
    },
    components: {
        CardBoxSmallBanner,
        CardBoxWide,
        IngFindYourNextCourse,
        FindYourNextCourse,
        CardBoxSmall,
        HeaderSizeOne,
        Layout,
    },
    props: {
        widgets: Object,
        tiles: Object,
        budget: Object,
        bookingsCount: Number,
        ordersInSyncCount: Number,
        error: Array,
        agreementGroup: String,
    },
}
</script>
